import React, { Component } from 'react'
import Header from '../../components/Header/Header'

export default class UnauthorisedAccess extends Component {
  render() {
    return (
      <div>
        <Header {...this.props} />
        <center>
          <h2>Not authorised to access Resource</h2>
        </center>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/UnauthorisedAccess/UnauthorisedAccess.js
 **/